<h2 class="accent-500 font-weight-900 m-0" mat-dialog-title>
  {{ "To Change Union" | translate }}
</h2>
<mat-dialog-content>
  <mat-form-field appearance="outline">
    <mat-label>{{ "Select the constituency" | translate }}</mat-label>
    <mat-select [(ngModel)]="selectedConstDropdown" name="selectedConstDropdown"
      (ngModelChange)="onConstDropdownChange()">
      <input style="padding: 18px; border-bottom: 1px solid; margin-bottom: 8px" autocomplete="off"
        [(ngModel)]="searchTxt" matInput placeholder="search" />

      <mat-option *ngFor="let data of constituencyList | search: searchTxt" [value]="data.Const_Id">
        {{ data.Const_name }}</mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>{{ "Select the union" | translate }}</mat-label>
    <mat-select [(ngModel)]="selectedDropdown" name="selectedDropdown" (ngModelChange)="onDropdownChange()">
      <mat-option *ngFor="let data of dropdownData" [value]="data.cons_circle_id">{{ data.cons_circle_name }}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <div *ngIf="showError" class="error-message mb-16">
    {{ error_msg | translate }}
  </div>
</mat-dialog-content>
<mat-dialog-actions align="center" class="mb-24">
  <button mat-raised-button class="mr-4 p-5 red" mat-dialog-close
    aria-label="Close dialog">{{ "Cancel" | translate }}</button>
  <button mat-button class="bg-success" [disabled]="selectedDropdown == null" (click)="onClickSubmit()">
    {{ "Submit" | translate }}
  </button>
  <button mat-button mat-dialog-close class="dialog-close" (click)="onClickCancel()">
    <mat-icon>close</mat-icon>
  </button>
</mat-dialog-actions>